<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <div class="write-txt">
          <p class="write-title">驳回原因：<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="请输入驳回原因" v-model="addObj.rfcontent"></textarea>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="searchBox clear">
            <div class="search-item">
              <p>昵称：</p>
              <input type="text" placeholder="请输入要搜索的昵称" v-model="obj.search">
            </div>
            <div class="search-item">
              <p>提现状态：</p>
              <el-select v-model="obj.status" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>支付类型：</p>
              <el-select v-model="obj.type" placeholder="请选择">
                <el-option
                  v-for="item in createList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.username">{{item.username}}</p>
              <p :title="item.total">{{item.total}}</p>
              <p :title="item.type==1?'微信':'支付宝'">{{item.type==1?'微信':'支付宝'}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p :title="item.status==0?'提现中':item.status==1?'提现成功':'已拒绝'">{{item.status==0?'提现中':item.status==1?'提现成功':'已拒绝'}}</p>
              <p :title="item.add_time">{{item.rfcontent}}</p>
              <p>
                <button title="拒绝" @click="RejectShow(item)" class="btn btn-revise">拒绝</button>
                <button title="再次提现" @click="WithdrawAgain(item)" class="btn btn-remove">再次提现</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getTransferList,Reject,Withdrawal} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "withdraw",
  data() {
    return {
      navId:'11',
      titleList:[
        {id:1,title:'提现ID'},
        {id:2,title:'用户昵称'},
        {id:4,title:'提现金额'},
        {id:5,title:'类型'},
        {id:6,title:'提现时间'},
        {id:7,title:'状态'},
        {id:8,title:'驳回原因'},
        {id:9,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      obj:{
        page:1,
        rows:10,
        type:'',
        status:'',
        search:'',
      },
      addObj:{
        rfcontent:'',
        id:'',
      },
      statusList:[
        {id:1,title:'审核中',value:0},
        {id:2,title:'提现成功',value:1},
        {id:3,title:'提现失败',value:2},
      ],
      createList:[
        {id:1,title:'支付宝'},
        {id:2,title:'微信'},
      ],
      totalPage:0,
      token:'',
      removeID:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
        type:'',
        status:'',
        search:'',
      };
      this.addObj = {
        rfcontent:'',
        id:'',
      }
      this.dataList = [];
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getTransferList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.rfcontent == ''){
        that.$message('请输入驳回原因！');
        return false;
      }
      try {
        const response = await Reject(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.addType = '';
          that.resetSub(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    RejectShow(e){
      this.addType = 'reject'
      this.addObj.id = e.id;
    },

    async WithdrawAgain(e){
      var that = this;
      try {
        const response = await Withdrawal({id:e.id},this.token);
        if(response.code == 200){
          that.$message('成功');
          that.removeType = '';
          that.resetSub();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.removeType = false;
      this.addType = '';
      this.addObj = {
        rfcontent:'',
        id:'',
      };
      this.removeID = '';
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 8 );
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox textarea{
    width: 80%;
    height: 500px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.searchBox>>>.search-item input{
  width: 160px;
}

.msgBox .contv{
  height: 80%;
}

.msgBox .btnBox{
  margin-top: 50px;
}

.msgBox>>>.el-radio__label{
  font-size: 15px;
}
.msgBox>>>.el-radio-group .el-radio{
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/user/withdraw.vue